<template>
  <div class="sticky-button" :class="{ mobile }" @click="store.isWindowMinimized = false">
    <img v-if="store.firstVisit" class="new-arrow" src="~@/assets/imgs/chatbot/new-arrow.webp" />
    <div class="line1">PATCH</div>
    <div class="line2">NOTES CHAT</div>
  </div>
</template>

<script setup lang="ts">
  import usePreloadImages from '@/helpers/usePreloadImages'
  import { useChatbotStore } from '@/store/Chatbot'
  import hoverImg from '@/assets/imgs/chatbot/sticky-button-hover.webp'
  const { mobile } = useDisplay()
  const store = useChatbotStore()

  usePreloadImages([hoverImg])
</script>

<style lang="scss" scoped>
  .sticky-button {
    position: relative;
    z-index: 2; // first visit overlay is 1
    margin: 0 -5px -10px 0;
    width: 140px;
    height: 140px;
    color: white;
    font-family: glory;
    font-weight: bold;
    cursor: pointer;
    transition: background-image 0.3s;
    background-image: url('@/assets/imgs/chatbot/sticky-button.webp');
    filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.5));
    &:hover {
      background-image: url('@/assets/imgs/chatbot/sticky-button-hover.webp');
    }
    // position: relative;
    // &::before {
    .line1 {
      position: absolute;
      font-size: 20px;
      top: 15px;
      left: 32px;
      transform: rotate(-18deg);
    }
    // &::after {
    .line2 {
      position: absolute;
      font-size: 20px;
      top: 34px;
      left: 13px;
      transform: rotate(-18deg);
    }
    &.mobile {
      scale: 0.5;
      bottom: -30px;
      right: -30px;
    }
  }

  .new-arrow {
    position: absolute;
    top: -70px;
    right: 0;
    filter: drop-shadow(0px 0px 7px rgba(0, 0, 0, 0.8));
  }
</style>
